<template>
    <v-app id="inspire">
        <v-navigation-drawer
                fixed
                v-model="drawer"
                app
        >
            <v-list dense>
                <v-list-tile
                  v-for="item in items"
                  :key="item.title"
                  :to="item.url"
                  @click="drawer = false"
                >
                    <v-list-tile-content>
                      <div v-if="item.has_divider"
                           style="width:100%;text-align:left;margin-left:0;height:1px;
                           border-bottom: 1px solid black; margin-bottom: 5px"></div>
                      <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                    </v-list-tile-content>
                </v-list-tile>
            </v-list>
        </v-navigation-drawer>
        <v-toolbar color="primary" dark fixed app>
            <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
            <v-toolbar-title>Dashboard Seguridad</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-menu :nudge-width="100">
                <v-toolbar-title slot="activator">
                    <span>{{ username }}</span>
                    <v-icon dark>fas fa-caret-down</v-icon>
                </v-toolbar-title>

                <v-list>
                    <v-list-tile
                      v-for="item in menu_items"
                      :key="item.title"
                      @click="logout"
                    >
                        <v-list-tile-title v-text="item.title"></v-list-tile-title>
                    </v-list-tile>
                </v-list>
            </v-menu>
        </v-toolbar>
        <v-content>
                <router-view></router-view>
        </v-content>
    </v-app>
</template>

<script>
import { getJWTData } from '../common/jwt.service';

export default {
  data: () => ({
    drawer: false,
    right: null,
    menu_items: [{
      title: 'Cerrar Sesión',
      url: '/',
    }],
  }),
  computed: {
    username() {
      return getJWTData().identity;
    },
    items() {
      let data = [];
      const routes = [
        /*
        {
          title: 'Autorización De Pre-Registro',
          url: '/pre_registro',
        },
        {
          title: 'Captura De Acceso',
          url: '/captura_accesos',
        },
        */
        {
          title: 'Accesos Del Día Y Pendientes',
          url: '/accesos',
        },
        /*
        {
          title: 'Accesos Colaboradores',
          url: '/accesos_colaboradores',
        },
        */
        {
          title: 'Histórico Accesos',
          url: '/historico',
          has_divider: true,
        },
        /*
        {
          title: 'Histórico Accesos Obra',
          url: '/historico_obras',
        },
        {
          title: 'Histórico Pre-Registro',
          url: '/historico_pre_registro',
        },
        {
          title: 'Histórico Accesos Colaboradores',
          url: '/historico_acceso_colaboradores',
        },
        */
        {
          title: 'Búsqueda Teléfono Residente',
          url: '/busqueda_telefono_residente',
          has_divider: true,
        },
        {
          title: 'Viviendas',
          url: '/captura_viviendas',
          has_divider: true,
        },
        {
          title: 'Residentes',
          url: '/captura_residentes',
        },
        /*
        {
          title: 'Servico Doméstico',
          url: '/listado_domesticos',
        },
        {
          title: 'Mascotas',
          url: '/listado_mascotas',
        },
        */
        {
          title: 'Vehículos',
          url: '/listado_vehiculos',
        },
        /*
        {
          title: 'Licencias',
          url: '/listado_licencias',
          has_divider: true,
        },
        */
        {
          title: 'Avisos',
          url: '/avisos',
          has_divider: true,
        },
        {
          title: 'Objetos Perdidos',
          url: '/objetos_perdidos',
        },
        /*
        {
          title: 'Colaboradores',
          url: '/listado_colaboradores',
          has_divider: true,
        },
        {
          title: 'Asistencias',
          url: '/asistencias',
        },
        */
        {
          title: 'Pórticos',
          url: '/porticos',
          has_divider: true,
        },
        {
          title: 'Usuarios',
          url: '/usuarios',
        },
      ];
      const rolesSOC = ['monitoristas', 'jefe_monitoristas'];
      const rolesEko = ['censo_residentes', 'admin_eko'];
      const rolesEkoReadOnly = ['atencion_residentes'];

      if (getJWTData().user_claims.role === 'admin') {
        data.push(...routes);
      }
      if (getJWTData().user_claims.role === 'accesos') {
        const allowed = ['/accesos', '/historico', '/historico_pre_registro', '/captura_viviendas'];
        data = routes.filter(route => allowed.includes(route.url));
      }
      if (getJWTData().user_claims.role === 'user') {
        const allowed = ['/accesos'];
        data = routes.filter(route => allowed.includes(route.url));
      }
      if (getJWTData().user_claims.role === 'censo') { // censo_colaboradores
        // const allowed = ['/captura_residentes', '/listado_colaboradores', '/captura_viviendas'];
        const allowed = ['/listado_colaboradores'];
        data = routes.filter(route => allowed.includes(route.url));
      }
      if (rolesEkoReadOnly.includes(getJWTData().user_claims.role)) {
        const allowed = ['/captura_residentes', '/captura_viviendas', '/busqueda_telefono_residente', '/listado_vehiculos'];
        data = routes.filter(route => allowed.includes(route.url));
      }
      if (rolesEko.includes(getJWTData().user_claims.role)) {
        const allowed = ['/captura_residentes', '/captura_viviendas', '/avisos', '/objetos_perdidos',
          '/busqueda_telefono_residente', '/listado_vehiculos'];
        data = routes.filter(route => allowed.includes(route.url));
      }
      if (rolesSOC.includes(getJWTData().user_claims.role)) {
        const allowed = ['/accesos', '/historico',
          '/historico_pre_registro', '/captura_viviendas', '/captura_residentes', '/avisos', '/objetos_perdidos',
          '/busqueda_telefono_residente', '/listado_vehiculos'];
        data = routes.filter(route => allowed.includes(route.url));
      }
      if (getJWTData().user_claims.role === 'rh' || getJWTData().user_claims.role === 'coordinador_operativo') {
        const allowed = ['/asistencias'];
        data = routes.filter(route => allowed.includes(route.url));
      }
      if (getJWTData().user_claims.role === 'avisos') {
        const allowed = ['/avisos', '/objetos_perdidos', '/captura_viviendas', '/captura_residentes', '/listado_vehiculos'];
        data = routes.filter(route => allowed.includes(route.url));
      }
      /*
      if (getJWTData().user_claims.role === 'censo_domesticos') {
        const allowed = ['/captura_residentes', '/captura_viviendas', '/listado_domesticos', '/listado_mascotas',
          '/busqueda_telefono_residente', '/listado_licencias', '/listado_vehiculos'];
        data = routes.filter(route => allowed.includes(route.url));
      }
      if (getJWTData().user_claims.role === 'censo_mascotas') {
        const allowed = ['/captura_residentes', '/captura_viviendas', '/listado_mascotas', '/busqueda_telefono_residente',
          '/listado_licencias', '/listado_vehiculos'];
        data = routes.filter(route => allowed.includes(route.url));
      }
      */

      return data;
    },
  },
  methods: {
    logout() {
      this.$store.dispatch('logout');
    },
  },
  props: {
  },
};
</script>
